module.exports = __webpack_public_path__ + "static/img/unifi-logo-new-with-text-white.a68ecb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unifi-logo-new-with-text-white.svg
// module id = qeeT
// module chunks = 0